
import NP from "number-precision"
import { soldOut, noPickupTime, getNumber, getSmallNumber, fen2Yuan, deliveryOnly } from "./js/common.js"
import redemptionDrawer from "@/components/collect/redemption-drawer"
import { getCollectProcess } from "@/api/collect"
import { flattenSelectItem } from "@/components/collect/format"
import { getLanguage } from "@/plugins/i18n"
import { callAsync } from "@/utils/cartResponse"

export default {
  name: "RedeemItems",
  components: {
    redemptionDrawer
  },
  provide() {
    return {
      getStoreId: () => this.storeId,
      source: "redeemItems"
    }
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    storeId: {
      type: [Number, String],
      default: ""
    },
    items: {
      type: Array,
      default: () => []
    },
    slaveStore: {
      type: Boolean,
      default: false
    },
    shipmentType: {
      type: Number,
      default: 0,
      required: true
    }
  },
  data() {
    return {
      loadingInstance: null,
      requestSuccess: false,
      redeemItem: {},
      dialogInfo: {}
    }
  },
  computed: {
    promotionList() {
      const result = this.items[0] || {}
      return result.promotionList || []
    }
  },
  mounted() {
    console.log("redeemItems=====>", this.items, this.promotionList)
    this.$bus.$off("add-cart-success", this.handleAddRedeemSuccess)
    this.$bus.$on("add-cart-success", this.handleAddRedeemSuccess)
  },
  beforeDestroy() {
    this.$bus.$off("add-cart-success", this.handleAddRedeemSuccess)
  },
  methods: {
    soldOut,
    noPickupTime,
    getNumber,
    getSmallNumber,
    fen2Yuan,
    deliveryOnly,
    showAbnormalState(item) {
      const state = item.wareStatus?.abnormalState
      const invalidWareFlag = item.wareStatus?.invalidWareFlag
      // 當 abnormalState 為 5 且 invalidWareFlag 不等於 1 時，不渲染
      if (state === 5 && invalidWareFlag !== 1) {
        return false
      }
      // 其他情況下，檢查 abnormalState 是否在指定列表中
      return [10, 11, 12, 5].includes(state)
    },
    getAbnormalStateText(item) {
      const state = item.wareStatus?.abnormalState
      switch (state) {
        case 10:
          // 仅香港
          return this.$t("cart.salesAreaHK")
        case 11:
          // 仅澳门
          return this.$t("cart.salesAreaMacao")
        case 12:
          // 指定门店
          return this.$t("cart.designatedStore")
        case 5:
          //  无履约实效下 售罄
          if (item.wareStatus.invalidWareFlag === 1 && ![10, 11, 12].includes(state)) return this.$t("cart.soldout")
        // eslint-disable-next-line no-fallthrough
        default:
          return ""
      }
    },
    maxTradeQty(item) {
      return item.promotionTrade && item.promotionTrade.maxTradeQty
    },
    // 已选择的换购品列表
    selectedTradeWareList(item) {
      return (item.promotionTrade && item.promotionTrade.selectedTradeWareList) || []
    },
    // 可选择的换购品列表
    optTradeWareList(item) {
      return (item.promotionTrade && item.promotionTrade.optTradeWareList) || []
    },
    // 换购品未选择完成
    isRedeemUnselectedCompleted(item) {
      return this.selectedTradeWareList(item).length < this.maxTradeQty(item)
    },
    // 已选择的换购品存在无效商品
    isSelectedExistSoldOut(item) {
      return this.selectedTradeWareList(item).some(ware => this.soldOut(ware))
    },
    // 全部无效
    isAllSoldOut(item) {
      return this.selectedTradeWareList(item).every(ware => this.soldOut(ware))
    },
    toProductDetail(item) {
      if (this.slaveStore) return
      this.$navigation.push({
        path: `${this.MAIN_PATH}/p/${encodeURIComponent(item.wareName)}/i/${item.skuId}.html`
      })
    },
    handleAddRedeemSuccess(source) {
      this.$nextTick(() => {
        if (source === "redeemItems") {
          this.getDialogInfo()
        }
      })
    },
    redeemPlaceholder(item) {
      if (!item.promotionTrade) {
        return ""
      }

      if (item.tradePrice == 0) {
        return this.$t("cart.redeemFreeMsg")
      } else {
        const { rewardSubMode } = item.promotionTrade
        // 立减: 1, 折扣: 2, 特价: 3
        if (rewardSubMode == 1) {
          // 立减
          return this.$t("cart.redeemVerticalReductionMsg", { value: this.fen2Yuan(item.tradePrice) })
        } else if (rewardSubMode == 2) {
          // 折扣(需要去掉小数)
          const discount = Math.floor(NP.divide(item.tradePrice, 100))
          if (discount == 100) {
            return this.$t("cart.redeemFreeMsg")
          } else if (discount < 100) {
            const lang = getLanguage()
            if (lang === "en_US") {
              // 英文环境
              return this.$t("cart.redeemDiscountMsg", { value: discount })
            } else {
              // 繁体中文环境
              let number = 100 - discount
              if (number % 10 == 0) {
                number = NP.divide(number, 10)
              }

              return this.$t("cart.redeemDiscountMsg", { value: number })
            }
          }
        } else if (rewardSubMode == 3) {
          // 特价
          return this.$t("cart.redeemSpecialOfferMsg", { value: this.fen2Yuan(item.tradePrice) })
        }
      }
    },
    handleDelete(item) {
      this.$emit("handleRedeemDelete", {
        type: "trade",
        promotionId: item.promotionId,
        items: this.selectedTradeWareList(item)
      })
    },
    startLoading() {
      this.loadingInstance = this.$loading({
        background: "rgba(0, 0, 0, 0)"
      })
    },
    endLoading() {
      this.loadingInstance && this.loadingInstance.close()
    },
    async getDialogInfo() {
      const params = {
        storeId: this.storeId,
        shipmentType: this.shipmentType,
        promotionId: this.redeemItem.promotionId,
        bestOffer: !!(this.redeemItem.promotionInfo && this.redeemItem.promotionInfo.bestofferFlag === 1)
      }
      const [error, { data }] = await callAsync(getCollectProcess(params))
      if (data) {
        this.requestSuccess = true
        this.dialogInfo = data.dialogInfo || {}
        flattenSelectItem(this.dialogInfo.selectedItemInfo)
      }

      return [error, data]
    },
    openRedeemDrawer(item) {
      this.requestSuccess = false
      this.redeemItem = item
      const soldOutItems = this.selectedTradeWareList(item).filter(ware => this.soldOut(ware)) || []

      const cb = async () => {
        this.startLoading()
        const [error, data] = await this.getDialogInfo()
        this.endLoading()
        if (data) {
          this.$nextTick(() => {
            this.$refs.redemptionDrawer.open()
          })
        }
      }
      // 打开弹窗之前先删除失效的换购品
      if (soldOutItems.length) {
        this.$emit("handleRedeemDelete", {
          type: "trade",
          promotionId: item.promotionId,
          items: soldOutItems,
          cb
        })
      } else {
        cb()
      }
    }
  }
}
